import axios from "axios";
import { toast } from "react-toastify";

export function errorFormat(err) {
  if (axios.isAxiosError(err)) {
    const data = err?.response?.data;
    const message = err?.response?.statusText;
    const status = err?.response?.status;

    /**
     * Display a toast notification for "Internal Server Error" (status code 500)
     * if the error message is a string
     */
    if (status === 500 && typeof data?.error === "string") {
      toast.error(data.error);
    }

    return { status, data, message };
  } else {
    // Handle non-Axios errors
    const errData = err?.message ?? "Unknown server error occurred";

    // Return the non-Axios error message
    return { status: 500, message: errData };
  }
}
